import {useEffect, useState} from "react";
import "./SingleClosedTicket.scss";
import {Link, useParams} from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";


import useFetch from "../../hooks/useFetch";
const SingleClosedTicket = () => {
  const [ticketClosed, setTicketClosed] = useState([]);
  const { ticketId } = useParams();
  const { data, loading, error } = useFetch(`/closed/${ticketId}`);

  useEffect(() => {
    setTicketClosed(data);
  }, [data]);


const dateTicket = () => {
  const dateCreated = new Date(ticketClosed.created_at);
  const dateUpdate = new Date(ticketClosed.updated_at);

  const date = {
    create_at : dateCreated.toLocaleString(),
    updated_at: dateUpdate.toLocaleString(),

  }
  return date;
}
const date = dateTicket()





  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          {loading ? (
              "loading"
          ) : (
          <div className="left">
            <Link to={`/closed/update/${ticketClosed.ticket_id}`} style={{textDecoration: "none"}}>
              <div className="editButton">Edit</div>
            </Link>
            <h1 className="title">Information Ticket Open Detail</h1>
            <div className="item">
              <img
                src="https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
                alt=""
                className="itemImg"
              />
              <div className="details">
                <h1 className="itemTitle">Detail Ticket Closed</h1>
                <div className="detailItem">
                  <span className="itemKey">Date Submit: </span>
                  <span className="itemValue">{date.create_at}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Ticket ID: </span>
                  <span className="itemValue">{ticketClosed.ticket_id}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Close Ticket By: </span>
                  <span className="itemValue">{ticketClosed.close_ticket_by}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">SLA: </span>
                  <span className="itemValue">{ticketClosed.sla}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Lampiran Document: </span>
                  <span className="itemValue">{ticketClosed.document_evidence}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">TT Aging: </span>
                  <span className="itemValue">{ticketClosed.tt_aging}</span>
                </div>
                <span className="itemKey">Last Updated AT: </span>
                <span className="itemValue">{date.updated_at}</span>
              </div>
            </div>
          </div>)}
        </div>
      </div>
    </div>
  );
};

export default SingleClosedTicket;
